<div class="container-fluid py-4">
  <!-- Header Action Row -->
  <div class="card border-0 bg-transparent mb-4">
    <div class="row align-items-center g-3">
      <!-- LEFT: Page Title & Subtitle Badge Context -->
      <div class="col-md">
        <div class="d-flex align-items-center gap-3">
          <h4 class="fw-bold text-dark mb-0 tracking-tight">
            Dealer Complaints Management
          </h4>
        </div>
      </div>

      <!-- RIGHT: Unified Interactive Controls Grid -->
      <div class="col-md-auto">
        <div class="d-flex flex-wrap align-items-center gap-2">
          <!-- Beautiful Inline Select Dropdown Wrapper -->
          <!-- Filter Launcher Button -->
          <button type="button"
            class="btn btn-outline-secondary border-secondary-subtle d-inline-flex align-items-center gap-2 py-2 px-3 fw-medium shadow-sm position-relative text-body-secondary"
            data-bs-toggle="modal" data-bs-target="#filterDialogModal">
            <i class="fa fa-solid fa-sliders"></i>
            <span>Filter Options</span>
            <!-- Optional: Visual dot indicator showing if active filters exist -->
            <span
              class="position-absolute top-0 start-100 translate-middle p-1 bg-primary border border-light rounded-circle">
              <span class="visually-hidden">Filters Active</span>
            </span>
          </button>


          <!-- Filter Overlay Dialog Box -->
          <div class="modal fade" id="filterDialogModal" tabindex="-1" aria-labelledby="filterDialogModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" style="max-width: 550px;">
              <div class="modal-content bg-body-tertiary border border-secondary-subtle shadow">

                <!-- Dialog Header -->
                <div class="modal-header border-bottom border-secondary-subtle bg-body p-3">
                  <div class="d-flex align-items-center gap-2" id="filterDialogModalLabel">
                    <i class="fa fa-solid fa-sliders text-body-secondary"></i>
                    <h6 class="modal-title fw-semibold text-body">Filter Parameters</h6>
                  </div>
                  <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal"
                    aria-label="Close"></button>
                </div>

                <!-- Dialog Content Body -->
                <div class="modal-body p-4">
                  <p class="text-body-secondary small mb-4">
                    Select the status criterion and define your desired date intervals below to narrow down the system
                    records.
                  </p>

                  <form class="row g-3">
                    <!-- Status Dropdown Field -->
                    <div class="col-12">
                      <label for="statusFilter" class="form-label text-body-secondary small fw-medium mb-1.5">Filter
                        Status</label>
                      <div class="position-relative">
                        <div
                          class="position-absolute top-50 start-0 translate-middle-y ps-3 text-body-secondary opacity-75 pointer-events-none z-3 small">
                          <i class="fa fa-solid fa-filter"></i>
                        </div>
                        <select id="statusFilter"
                          class="form-select ps-5 py-2.5 bg-body text-body-emphasis border-secondary-subtle shadow-sm focus-ring"
                          style="--bs-focus-ring-color: rgba(var(--bs-primary-rgb), 0.25)" [(ngModel)]="selectedStatus"
                          name="statusFilter">
                          @for (status of complainStatuses; track status) {
                          <option [value]="status" class="bg-body text-body py-2">{{ status }}</option>
                          }
                        </select>
                      </div>
                    </div>

                    <!-- Start Date Field with Interactive Picker Action -->
                    <div class="col-12 col-sm-6">
                      <label for="startDateFilter" class="form-label text-body-secondary small fw-medium mb-1.5">Start
                        Date</label>
                      <div class="position-relative">
                        <!-- Clickable Icon to toggle date selection -->
                        <button type="button" (click)="startDatePicker.showPicker()"
                          class="btn border-0 position-absolute top-50 start-0 translate-middle-y ps-3 text-body-secondary opacity-75 z-3 small">
                          <i class="fa fa-solid fa-calendar-alt"></i>
                        </button>

                        <input type="text" id="startDateFilter"
                          class="form-control ps-5 py-2.5 bg-body text-body-emphasis border-secondary-subtle shadow-sm focus-ring"
                          style="--bs-focus-ring-color: rgba(var(--bs-primary-rgb), 0.25)" [(ngModel)]="filterStartDate"
                          name="startDateFilter" placeholder="DD/MM/YYYY" maxlength="10" autocomplete="off"
                          (input)="onDateInput($event, 'start')" />

                        <!-- Hidden native channel layer acting purely as the interactive selector popup -->
                        <input type="date" #startDatePicker
                          class="position-absolute top-0 start-0 opacity-0 pointer-events-none"
                          (change)="onPickerSelect($event, 'start')">
                      </div>
                    </div>

                    <!-- End Date Field with Interactive Picker Action -->
                    <div class="col-12 col-sm-6">
                      <label for="endDateFilter" class="form-label text-body-secondary small fw-medium mb-1.5">End
                        Date</label>
                      <div class="position-relative">
                        <!-- Clickable Icon to toggle date selection -->
                        <button type="button" (click)="endDatePicker.showPicker()"
                          class="btn border-0 position-absolute top-50 start-0 translate-middle-y ps-3 text-body-secondary opacity-75 z-3 small">
                          <i class="fa fa-solid fa-calendar-alt"></i>
                        </button>

                        <input type="text" id="endDateFilter"
                          class="form-control ps-5 py-2.5 bg-body text-body-emphasis border-secondary-subtle shadow-sm focus-ring"
                          style="--bs-focus-ring-color: rgba(var(--bs-primary-rgb), 0.25)" [(ngModel)]="filterEndDate"
                          name="endDateFilter" placeholder="DD/MM/YYYY" maxlength="10" autocomplete="off"
                          (input)="onDateInput($event, 'end')" />

                        <!-- Hidden native channel layer acting purely as the interactive selector popup -->
                        <input type="date" #endDatePicker
                          class="position-absolute top-0 start-0 opacity-0 pointer-events-none"
                          (change)="onPickerSelect($event, 'end')">
                      </div>
                    </div>
                  </form>
                </div>

                <!-- Dialog Footer Actions -->
                <div
                  class="modal-footer border-top border-secondary-subtle bg-body p-3 d-flex justify-content-end gap-2">
                  <button type="button"
                    class="btn btn-outline-secondary border-secondary-subtle py-2 px-3 fw-medium small text-body-secondary"
                    data-bs-dismiss="modal" (click)="clearFilters()">
                    Clear All
                  </button>
                  <button type="button"
                    class="btn btn-primary py-2 px-4 fw-medium small d-flex align-items-center gap-2 shadow-sm"
                    data-bs-dismiss="modal" (click)="applyFilters()">
                    <i class="fa fa-solid fa-check"></i>
                    <span>Submit Query</span>
                  </button>
                </div>

              </div>
            </div>
          </div>

          <!-- Sleek Action Button -->
          <button type="button"
            class="btn btn-primary px-4 py-2 fw-semibold d-flex align-items-center gap-2 shadow-sm rounded-3 btn-hover-transform"
            (click)="showModal.set(true)">
            <i class="fa fa-solid fa-plus fs-7"></i>
            <span>New Complain</span>
          </button>

          @if(isDownloadAccess()) {
          <button type="button"
            class="btn btn-sm btn-outline-success d-inline-flex align-items-center gap-2 px-3 py-2 fw-semibold"
            data-bs-toggle="modal" data-bs-target="#downloadCSVModal">
            <i class="bi bi-download"></i>
            <span>Download CSV</span>
          </button>
          }


        </div>
      </div>
    </div>
  </div>

  <!-- Loading State via Block Syntax -->
  @if (isLoading()) {
  <div class="d-flex justify-content-center align-items-center my-5 py-5 text-secondary">
    <div class="spinner-border text-primary me-3" role="status"></div>
    <span>Loading complaints...</span>
  </div>
  } @else {
  <!-- Responsive Table Card Container -->
  <div class="card border-0 shadow-sm overflow-hidden rounded-3">
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0 custom-dashboard-table">
        <thead class="table-light border-bottom">
          <tr class="text-uppercase tracking-wider text-muted fs-7 fw-bold">
            <th class="ps-4 py-3" style="width: 80px">Sr No.</th>
            <th class="py-3">Dealer Account</th>
            <th class="py-3">Subject Title</th>
            <th class="py-3">Description</th>
            <th class="py-3">Start Date</th>
            <th class="py-3">End Date</th>
            <th class="py-3" style="width: 140px">Status</th>
            <th class="pe-4 py-3 text-end" style="width: 130px">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (item of complaints() | paginate: { itemsPerPage: pageSize(),
          currentPage: page() + 1, totalItems: allTotal(), }; track
          item.complainId) {
          <tr class="clickable-row transition-all" (click)="navigateToDetail(item.complainId)">
            <!-- Serial Index -->
            <td class="ps-4 font-monospace text-secondary fs-6">
              {{ item.srNo }}
            </td>

            <!-- Dealer Login with Profiler Icon Hint -->
            <td>
              <div class="d-flex align-items-center gap-2">
                <div class="table-avatar bg-light text-primary border fw-semibold rounded-circle">
                  <i class="fa fa-solid fa-user-tie fs-7"></i>
                </div>
                <span class="fw-semibold text-dark">{{ item.dealerLoginName }}</span>
              </div>
            </td>

            <!-- Title -->
            <td class="fw-bold text-dark-emphasis">{{ item.title }}</td>

            <!-- Description with Truncation -->
            <td>
              <p class="text-muted mb-0 text-truncate text-wrap-hover fs-6" style="max-width: 280px"
                title="{{ item.description }}">
                {{ item.description }}
              </p>
            </td>

            <!-- Start Date -->
            <td class="text-secondary-emphasis fs-6">
              {{ item.startDate }}
            </td>

            <!-- End Date -->
            <td class="text-secondary-emphasis fs-6">
              {{ item.endDate || '-' }}
            </td>

            <!-- Beautiful Soft-Tint Badges (Modern Alternative to Heavy Full-Bright Colors) -->
            <td>
              <span
                class="badge rounded-pill px-3 py-2 text-uppercase font-monospace tracking-wide fs-8 d-inline-flex align-items-center gap-1"
                [ngClass]="{
                      'bg-success-subtle text-success border border-success-subtle': item.status === 'OPEN',
                      'bg-danger-subtle text-danger border border-danger-subtle': item.status === 'CLOSE',
                      'bg-warning-subtle text-warning-emphasis border border-warning-subtle': item.status === 'PROCESSING'
                    }">
                <span class="status-dot animate-pulse-dot" [ngClass]="{
                  'bg-success': item.status === 'OPEN',
                  'bg-danger': item.status === 'CLOSE',
                  'bg-warning': item.status === 'PROCESSING'
                }"></span>
                {{ item.status }}
              </span>
            </td>

            <!-- Slick Action Button aligned nicely inside row cell -->
            <td class="pe-4 text-end">
              <!-- stopPropagation stops row double-firing events when tapping inner elements -->
              <button class="btn btn-sm btn-action-arrow border shadow-xs btn-hover-slide"
                (click)="$event.stopPropagation(); navigateToDetail(item.complainId)">
                <span>View</span>
                <i class="fa fa-solid fa-chevron-right fs-8 ms-1"></i>
              </button>
            </td>
          </tr>
          } @empty {
          <tr>
            <td colspan="8" class="text-center py-5 my-4 text-muted bg-linear-light">
              <div class="py-4">
                <div class="empty-icon-wrapper mb-3 mx-auto shadow-xs">
                  <i class="fa fa-regular fa-folder-open text-secondary fs-3"></i>
                </div>
                <h5 class="fw-bold text-dark mb-1">
                  No Active Correspondence Found
                </h5>
                <p class="text-secondary small mb-0">
                  Dealer complaint pipelines are currently synchronized clear.
                </p>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="text-center mt-4">
    <pagination-controls [maxSize]="20" previousLabel="Prev" nextLabel="Next" [responsive]="true"
      (pageChange)="handlePageChange($event)"></pagination-controls>
  </div>

  }

  <!-- Create Complaint Modal Popup (Bootstrap Structure Overlay) -->
  @if (showModal()) {
  <div class="modal fade show d-block" style="background: rgba(0, 0, 0, 0.5)" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 shadow">
        <div class="modal-header bg-light">
          <h5 class="modal-title fw-bold">New Dealer Complaint</h5>
          <button type="button" class="btn-close" aria-label="Close" (click)="resetForm()"></button>
        </div>

        <form (ngSubmit)="onSubmit()">
          <div class="modal-body py-4">
            <div class="mb-3">
              <label for="title" class="form-label fw-semibold text-secondary">Complaint Title</label>
              <input type="text" id="title" [ngModel]="newTitle()" (ngModelChange)="newTitle.set($event)" name="title"
                class="form-control" required placeholder="Brief summary of the issue" />
            </div>

            <div class="mb-0">
              <label for="description" class="form-label fw-semibold text-secondary">Full Description</label>
              <textarea id="description" [ngModel]="newDescription()" (ngModelChange)="newDescription.set($event)"
                name="description" class="form-control" rows="4" required
                placeholder="Provide exact error or details here"></textarea>
            </div>
          </div>

          <div class="modal-footer bg-light border-top-0">
            <button type="button" class="btn btn-secondary px-4" (click)="resetForm()">
              Cancel
            </button>
            <button type="submit" class="btn btn-primary px-4" [disabled]="isFormInvalid()">
              Submit Complaint
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  }
</div>


<!-- Download Configuration Dialog Box -->
<div class="modal fade" id="downloadCSVModal" tabindex="-1" aria-labelledby="downloadCSVModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 450px;">
    <div class="modal-content bg-body-tertiary border border-secondary-subtle shadow">

      <!-- Dialog Header -->
      <div class="modal-header border-bottom border-secondary-subtle bg-body p-3">
        <div class="d-flex align-items-center gap-2" id="downloadCSVModalLabel">
          <i class="fa fa-solid fa-file-export text-success"></i>
          <h6 class="modal-title fw-semibold text-body">Export CSV Report</h6>
        </div>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Dialog Body Input Field -->
      <div class="modal-body p-4">
        <label for="csvFileNameInput" class="form-label text-body-secondary small fw-medium mb-1.5">
          Assign File Name <span class="text-danger">*</span>
        </label>

        <div class="position-relative">
          <div
            class="position-absolute top-50 start-0 translate-middle-y ps-3 text-body-secondary opacity-75 pointer-events-none z-3 small">
            <i class="fa fa-solid fa-file-signature"></i>
          </div>
          <input type="text" id="csvFileNameInput"
            class="form-control ps-5 py-2.5 bg-body text-body-emphasis border-secondary-subtle shadow-sm focus-ring"
            style="--bs-focus-ring-color: rgba(var(--bs-success-rgb), 0.25)"
            placeholder="Enter file name (e.g., complaints_2026)" [(ngModel)]="downloadFileName" name="csvFileNameInput"
            autocomplete="off" required />
        </div>
        <p class="text-body-secondary fs-8 mt-2 mb-0">
          * Active filters (Status, Date Intervals) will apply automatically to the file.
        </p>
      </div>

      <!-- Dialog Action Buttons -->
      <div class="modal-footer border-top border-secondary-subtle bg-body p-3 d-flex justify-content-end gap-2">
        <button type="button"
          class="btn btn-outline-secondary border-secondary-subtle py-2 px-3 fw-medium small text-body-secondary"
          data-bs-dismiss="modal">
          Cancel
        </button>
        <button type="button"
          class="btn btn-success py-2 px-4 fw-medium small d-flex align-items-center gap-2 shadow-sm"
          [disabled]="!downloadFileName().trim()" data-bs-dismiss="modal"
          (click)="downloadReport()">
          <i class="fa fa-solid fa-download"></i>
          <span>Generate File</span>
        </button>
      </div>

    </div>
  </div>
</div>
